import { render, staticRenderFns } from "./ReviewWorkplaceForm.vue?vue&type=template&id=643f1498"
import script from "./ReviewWorkplaceForm.vue?vue&type=script&lang=js"
export * from "./ReviewWorkplaceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports